<template>
  <div class="box">
    <!-- 日程标题 -->
    <slot name="title" :pptInfo="pptInfo">
      <com-h1 title="大会日程" :title-en="pptInfo.word" :link="pptInfo.link"></com-h1>
    </slot>

    <schedule-pc v-if="this.$store.state.screen === 'pc'"></schedule-pc>
    <schedule-m v-if="this.$store.state.screen === 'mobile' &&  $store.state.info.scheduleDays.length"></schedule-m>
  </div>
</template>

<script>
import SchedulePc from './schedule-pc'
import ScheduleM from './schedule-m'
import ComH1 from '../../com-h1'

export default {
  data () {
    return {}
  },
  created: function () {
  },
  filters: {
  },
  components: {
    SchedulePc,
    ScheduleM,
    ComH1
  },
  methods: {},
  computed: {
    pptInfo () {
      let beginTime = Date.parse(this.$store.state.info.beginTime) / 1000
      let timenow = Date.now() / 1000
      if (timenow < beginTime) {
        return {
          word: '',
          link: ''
        }
      } else {
        return {
          word: '点击查看全部 PPT',
          link: this.$store.state.ppt_list
        }
      }
    }
  }
}
</script>
